import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageCkeck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackageCkeck"><Path d="M11.5 20.5H3.5V3.5H8.5M8.5 3.5H15.5M8.5 3.5V9.5H15.5V3.5M15.5 3.5H20.5V12.5M15.25 18.5978L17.1522 20.5L21.5 16.1522" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackageCkeck;
